import { ModalCloseButton } from './ModalCloseButton';
import { DialogShell } from './DialogShell';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirming?: boolean;
}

/** Modale de confirmation simple (suppression, etc.). */
export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  confirming = false,
}) => {
  const titleId = 'confirm-dialog-title';

  return (
    <DialogShell
      isOpen={isOpen}
      onClose={onCancel}
      titleId={titleId}
      overlayClassName="publish-confirmation-overlay"
      dialogClassName="publish-confirmation-modal"
    >
      <ModalCloseButton onClick={onCancel} className="publish-modal-close" />
      <h2 id={titleId} className="publish-confirmation-title">
        {title}
      </h2>
      <button
        type="button"
        className="publish-confirm-button"
        onClick={onConfirm}
        disabled={confirming}
      >
        {confirmLabel}
      </button>
      <button
        type="button"
        className="publish-cancel-link"
        onClick={onCancel}
        disabled={confirming}
      >
        {cancelLabel}
      </button>
    </DialogShell>
  );
};
